// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"430":"6196225d","670":"e5b2567d"}[chunkId] + ".chunk.css";
};